module.exports = __webpack_public_path__ + "img/ic_user_location.1e81ff9e.png";